import Phaser from 'phaser';

/**
 * Generic fade-to-black scene transition.
 * Fades the current scene's camera out, then executes the callback.
 *
 * @param scene  The scene initiating the transition
 * @param onFaded Callback executed once the fade-out completes
 * @param duration Fade duration in ms (default 200)
 */
export function fadeToScene(
  scene: Phaser.Scene,
  onFaded: () => void,
  duration = 200,
): void {
  scene.cameras.main.fadeOut(duration, 0, 0, 0);
  scene.cameras.main.once('camerafadeoutcomplete', onFaded);
}
